import React, { useContext } from 'react';
import useCameraInputHook from './CameraInput.hook.js';
import { ThemeContext } from '../../../shared/contexts/Theme.context.js';
import { BookingContext } from '../../../shared/contexts/Booking.context.js';
import { LanguageContext } from '../../../shared/contexts/Language.context.js';
import CustomButton from '../../CustomButton/CustomButton.jsx';
import { Modal } from 'antd';
import CamSnapshot from '../DocumentInput/CamSnapshot.jsx';
import Loader from '../../../shared/loaders/Loader.jsx';
import { LeftOutlined } from '@ant-design/icons';

export default function CameraInput({ field, setCurrentFormValue, checkinGuestId }) {
  const { state: theme } = useContext(ThemeContext);
  const {
    state: { hotelId },
  } = useContext(BookingContext);
  const {
    state: { literals },
  } = useContext(LanguageContext);
  const { state, actions } = useCameraInputHook({
    hotelId,
    setCurrentFormValue,
    field,
    checkinGuestId,
  });

  return (
    <div style={{ width: '100%' }}>
      <div style={{ display: 'flex', flexDirection: 'column' }}>
        {state.file?.name && <div style={{ marginBottom: 16 }}>{state.file.name}</div>}
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <CustomButton
            text={
              state.imageUrl
                ? literals['guestForm.additionalDocument.editButton']
                : literals['guestForm.additionalDocument.uploadButton']
            }
            type="text"
            small
            loading={state.loading}
            onClick={() => actions.setShowCameraModal(true)}
          />
        </div>
      </div>
      <Modal visible={state.showCameraModal} closable={false} footer={null} destroyOnClose={true}>
        {state.loading ? (
          <div
            style={{
              minWidth: 100,
              minHeight: 170,
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <Loader></Loader>
          </div>
        ) : (
          <div>
            {!state.imageUrl && (
              <LeftOutlined
                style={{ fontSize: 18, marginBottom: 16 }}
                onClick={() => actions.setShowCameraModal(false)}
              />
            )}
            <div
              style={{
                justifyContent: 'center',
                alignItems: 'center',
                display: 'grid',
              }}
            >
              <CamSnapshot
                theme={theme}
                handleChange={actions.handleCameraChange}
                imageUrl={state.imageUrl}
                onSaveImage={actions.onSaveImage}
                onRetakeImage={actions.onRetakeImage}
                setStreamRef={actions.setStreamRef}
              />
            </div>
          </div>
        )}
      </Modal>
    </div>
  );
}
